import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ACTIONS from '../redux/actions/Page';

import ProjectsArchive from './ProjectsArchive';

import { withRouter } from 'react-router-dom';

import classnames from 'classnames';

function mapStateToProps(state) {
  return {
    projects: state.Page.projects,
  };
}

function dispatchToProps(dispatch) {
  return {
    fetchNewArchive: bindActionCreators(ACTIONS.fetchNewArchive, dispatch),
  };
}

class ArchiveNew extends React.PureComponent {
  tagIndex = [];

  constructor(props) {
    super(props);
    this.state = {
      activeEntry: null,
    };
  }

  componentDidMount() {
    if (!this.props.archive) {
      this.props.fetchNewArchive();
    }
    // this.handleResize();
    // window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    // window.removeEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps) {
    // console.log(this.props.opacity);
    // if (prevProps.tags === null && this.props.tags !== null) {
    //   this.buildIndex();
    // }
  }

  render() {
    const { locked } = this.props;
    const cls = classnames('Archive-new', {
      'Archive--active': this.props.active,
      'is-unlocked': !locked,
    });
    const style = {
      opacity: this.props.opacity,
    };

    const projects = this.props.archive || this.props.projects;

    return (
      <div className={cls}>
        <div className="Archive-body" style={style}>
          <ProjectsArchive projects={projects} />
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(mapStateToProps, dispatchToProps)(ArchiveNew)
);



// WEBPACK FOOTER //
// ./src/js/components/ArchiveNew.jsx